import { render, staticRenderFns } from "./Under15List.vue?vue&type=template&id=504a97d1"
import script from "./Under15List.vue?vue&type=script&lang=js"
export * from "./Under15List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports